/**
 * アプリケーション設定
 * 環境に応じた設定値を管理します
 */

// 現在の環境を取得
const ENV = process.env.NODE_ENV || 'development';

// 環境ごとの設定
const configs = {
  // 開発環境設定
  development: {
    // APIエンドポイントの設定
    apiBase: 'https://deli-ns.com/api',
    debugApiBase: 'https://deli-ns.com/debug',
    apiTimeout: 10000,
    
    // アプリケーション設定
    appName: 'DNS開発環境',
    logLevel: 'debug',
    
    // 機能フラグ
    features: {
      enableAnalytics: false,
      enableErrorReporting: false,
      enableTestFeatures: true
    }
  },
  
  // 本番環境設定
  production: {
    // APIエンドポイントの設定
    // Firebase Hosting rewrite により /api/** は Cloud Run に転送される
    apiBase: '',
    debugApiBase: '/debug',
    apiTimeout: 30000,
    
    // アプリケーション設定
    appName: 'デリヘル専用SNS「DNS」',
    logLevel: 'silent', // すべてのデバッグログを非表示
    
    // 機能フラグ
    features: {
      enableAnalytics: true,
      enableErrorReporting: true,
      enableTestFeatures: false
    }
  },
  
  // テスト環境設定（必要に応じて）
  test: {
    apiBase: 'https://deli-ns.com/api',
    debugApiBase: 'https://deli-ns.com/debug',
    apiTimeout: 1000,
    appName: 'DNS テスト環境',
    logLevel: 'debug',
    features: {
      enableAnalytics: false,
      enableErrorReporting: false,
      enableTestFeatures: true
    }
  }
};

// 環境に応じた設定をエクスポート
const config = configs[ENV];

// 環境名を追加
config.environment = ENV;

// デバッグ情報
if (ENV !== 'production') {
  
}

// API設定（ダブルスラッシュ問題解決のため末尾スラッシュを削除）
// Firebase Hosting の rewrite で /api/** → Cloud Run にルーティングされるため、
// 本番環境では同一オリジン（空文字列）を使用する
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const DEBUG_API_BASE_URL = process.env.REACT_APP_API_BASE_URL 
  ? `${process.env.REACT_APP_API_BASE_URL}/debug`
  : '/debug';

// フロントエンドのURL設定（CORSで使用）
const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || 'https://deli-ns.com';

// SocketIO URLの追加
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'wss://deli-ns.com';

export default {
  ...config,
  API_BASE_URL,
  DEBUG_API_BASE_URL,
  FRONTEND_URL,
  SOCKET_URL
}; 